import { ReactNode } from 'react';
import Sidebar from './Sidebar';

interface LayoutProps {
    children: ReactNode;
}

export default function Layout({ children }: LayoutProps) {
    return (
        <div className="min-h-screen bg-primary flex flex-col lg:flex-row">
            {/* Sidebar */}
            <Sidebar />

            {/* Main Content */}
            <main className="flex-1 overflow-x-hidden">
                <div className="max-w-7xl mx-auto px-6 py-6">
                    {children}
                </div>
            </main>
        </div>
    );
}
